import { Component, OnDestroy } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { User } from 'src/app/models/user';
import { SettingsService } from '../settings.service';
import { Subscription } from 'rxjs';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../settings-breadcrumb.service';
import { IdentityWhitelabelApiClient } from 'src/app/services/api-clients/identity-whitelabel.api-client';
import { IdsForSettingsService } from '../ids-for-settings.service';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { IdentitySystemApiClient } from 'src/app/services/api-clients/identity-system.api-client';

@Component({
  templateUrl: './branding.page.html'
})
export class BrandingPage {

  public INFO_HeaderName: string = "Info";
  public GENERAL_HeaderName: string = "General";
  public IMAGES_HeaderName: string = "Images";
  public COLOURS_HeaderName: string = "Colours";
  public EMAIL_HeaderName: string = "Email";
  activeTab = this.INFO_HeaderName;
  premiumRequired: boolean = false;

  enableBrandingModalRef!: NgbModalRef;
  disableBrandingModalRef!: NgbModalRef;
  brandingAvailable: boolean = false;
  brandingEditable: boolean = false;
  organisation: any;
  whiteLabel: any;
  system: any;
  user!: User;
  brandingStatus: boolean = false;
  ssorequired: boolean = false;
  isLoading = true;

  constructor(
    protected settingsService: SettingsService,
    protected idsForSettingsService: IdsForSettingsService,
    protected settingsBreadCrumbService: SettingsBreadCrumbService) {

    this.user = this.settingsService.user;

  }

  updateBrandingStatusOrganisation(status: any) {
    this.settingsService.updateBrandingStatus(status, this.organisation);
  }
  updateBrandingStatusWhiteLabel(statusAsString: any) {
    var newBrandingStatus = statusAsString == "enable";
    this.settingsService.updateBrandingStatusWhiteLabel(newBrandingStatus, this.whiteLabel.guid);
  }

  updatebrandingEditable(event: boolean) {
    this.brandingEditable = event;
  }

}

@Component({
  templateUrl: './branding.page.html'
})
export class OrganisationBrandingPage extends BrandingPage implements OnDestroy {

  selectedOrganisationId: string = "";
  organisationIdSubscription: Subscription;
  override premiumRequired: boolean = true;

  constructor(private identityOrganisationApiClient: IdentityOrganisationApiClient,
    protected override settingsService: SettingsService,
    protected override idsForSettingsService: IdsForSettingsService,
    protected override settingsBreadCrumbService: SettingsBreadCrumbService) {
    super(settingsService, idsForSettingsService, settingsBreadCrumbService);

    this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
      this.isLoading = true;
      this.selectedOrganisationId = organisationId;
      // setup specialised breadcrumb with organisationId
      this.settingsBreadCrumbService.SetOrganisationCrumbs(BreadCrumbOptions.Organisation_Branding(this.selectedOrganisationId));

      this.identityOrganisationApiClient.getOrganisation(organisationId).subscribe(organisationData => {
        this.organisation = organisationData.organisation;
        // whether BRANDING, CAN be enabled.
        this.brandingAvailable = this.organisation.whitelabelEnabled;
        this.settingsService.getSsorequired().subscribe({
          next: (data: any) => {
            this.ssorequired = data.ssoRequired;
          }
        });
        this.settingsService.getBrandingStatusOrganisation(this.selectedOrganisationId).subscribe((data: any) => {
          // Whether BRANDING is ACTUALLY enabled
          this.brandingStatus = data; // whether branding is activly being used
          // navigate
          this.navigateToRelevantTab(this.brandingAvailable, this.brandingStatus);
          this.isLoading = false;
        });
      });
    });
  }

  ngOnDestroy(): void {
    this.organisationIdSubscription.unsubscribe();
  }

  navigateToRelevantTab(brandingIsAllowed: boolean, brandingIsEnabled: boolean) {

    // when switching between organisations its alot nicer to be able to stay on your tab, to see differences.
    // so we only switch you when you are on the info tab (which is gone when branding available)

    // when allowed and enabled -> navigate from the info (when not used) to the base page general (when in use)
    if (brandingIsAllowed && brandingIsEnabled) {
      // with branding allowed, and enabled, we only need to navigate away from INFO if there
      if (this.activeTab == this.INFO_HeaderName) {
        this.activeTab = this.GENERAL_HeaderName;
        return;
      }
      // else its okay to stay on current tab
      return;


    } else if (!brandingIsAllowed) {
      // without branding allowed you must always go to INFO
      this.activeTab = this.INFO_HeaderName;
      return;

    } else if (!brandingIsEnabled) {
      // with branding allowed, but not enabled, we only need to navigate away from INFO if there
      if (this.activeTab == this.INFO_HeaderName) {
        this.activeTab = this.GENERAL_HeaderName;
        return;
      }
      // else stay on current tab
      return;
    }
    // fallback
    this.activeTab = this.INFO_HeaderName;

  }
}

@Component({
  templateUrl: './branding.page.html'
})
export class WhitelabelBrandingPage extends BrandingPage implements OnDestroy {

  selectedWhiteLabelId: string = "";
  whiteLabelIdSubscription: Subscription;
  override premiumRequired: boolean = true;

  constructor(private identityWhiteLabelApiClient: IdentityWhitelabelApiClient,
    protected override settingsService: SettingsService,
    protected override idsForSettingsService: IdsForSettingsService,
    protected override settingsBreadCrumbService: SettingsBreadCrumbService) {
    super(settingsService, idsForSettingsService, settingsBreadCrumbService);

    this.whiteLabelIdSubscription = this.idsForSettingsService.selectedWhiteLabelId$.subscribe(whiteLabelId => {
      this.isLoading = true;
      this.selectedWhiteLabelId = whiteLabelId;
      this.activeTab = this.GENERAL_HeaderName;

      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetWhiteLabelCrumbs(BreadCrumbOptions.Whitelabel_Branding(this.selectedWhiteLabelId));
      if (!whiteLabelId) {
        return;
      }
      this.identityWhiteLabelApiClient.getWhitelabel(whiteLabelId).subscribe(whiteLabelData => {
        this.whiteLabel = whiteLabelData.whiteLabel;
        this.brandingAvailable = this.whiteLabel.whitelabelEnabled;
        this.settingsService.getSsorequired().subscribe({
          next: (data: any) => {
            this.ssorequired = data.ssoRequired;
          }
        });
        this.settingsService.getBrandingStatusWhiteLabel(this.selectedWhiteLabelId).subscribe({
          next: (data: any) => {
            this.brandingStatus = data;
            this.isLoading = false;
          }
        });
      });
    });
  }

  ngOnDestroy(): void {
    this.whiteLabelIdSubscription.unsubscribe();
  }

}

@Component({
  templateUrl: './branding.page.html'
})
export class SystemBrandingPage extends BrandingPage implements OnDestroy {

  selectedSystemId: string = "";
  systemIdSubscription: Subscription;

  constructor(private identitySystemApiClient: IdentitySystemApiClient,
    protected override settingsService: SettingsService,
    protected override idsForSettingsService: IdsForSettingsService,
    protected override settingsBreadCrumbService: SettingsBreadCrumbService) {
    super(settingsService, idsForSettingsService, settingsBreadCrumbService);

    this.systemIdSubscription = this.idsForSettingsService.selectedSystemId$.subscribe(systemId => {
      this.isLoading = true;
      this.selectedSystemId = systemId;
      this.activeTab = this.GENERAL_HeaderName;

      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetSystemCrumbs(BreadCrumbOptions.System_Branding);
      if (!systemId) {
        return;
      }
      this.identitySystemApiClient.getSystem(systemId).subscribe(systemData => {
        this.system = systemData.system;

        this.settingsService.getSsorequired().subscribe({
          next: (data: any) => {
            this.ssorequired = data.ssoRequired;
          }
        });
        this.settingsService.getBrandingStatusSystem(this.selectedSystemId).subscribe({
          next: (data: any) => {
            this.brandingStatus = data;
            this.isLoading = false;
          }
        });
      });
    });
  }

  ngOnDestroy(): void {
    this.systemIdSubscription.unsubscribe();
  }

}
